export const Types = {
    Unsupported: 'unsupported',
    Image: 'image',
    Video: 'video',
    Pdf: 'pdf',
    Web: 'web'
}

export function getType(extension) {
    switch(extension) {
        case 'avi':
            return Types.Unsupported;

        case 'jpg':
        case 'jpeg':
        case 'png':
        case 'jfif':
        case 'webp':
            return Types.Image;

        case 'mp4':
        case 'wmv':
        case 'm4v':
        case 'mov':
            return Types.Video;
        
        case 'pdf':
            return Types.Pdf;

        default:
            return Types.Web;
    }
}